import { resolve, reject } from 'redux-optimist-promise';
import {
  getPriceDetailFragment,
  transportDetailsFragment,
} from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { PROPOSAL_GET_ADDITIONAL_TRANSPORT } from 'Utils/request/requestDictionary';
import createAction from 'Store/utils/createAction';
import { graphqlify } from 'Utils/graphql';
const FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
const SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
type AdditionalTransportArgs = {
  proposalId: string;
  appContext: AppContext;
  searchCriterias?: TransportSearchCriteria;
};

function _runAdditionalTransportsQuery({
  proposalId,
  appContext,
  searchCriterias,
}: AdditionalTransportArgs): Promise<any> {
  const query = `
    {
      additionalTransports(proposalId : "${proposalId}" ${searchCriterias ? `, searchCriteria: ${graphqlify(searchCriterias)}` : ''}) {
        id
        price {
          ...priceDetails
        }
        totalDifferentialPrice {
          ...priceDetails
        }
        inbound {
          ...transportsDetails
        }
        outbound {
          ...transportsDetails
        }
      }
    }
    ${transportDetailsFragment}
    ${getPriceDetailFragment(appContext.locale)}
  `;
  return graphQLClient.runNoCacheQuery(query, appContext, {
    requestName: PROPOSAL_GET_ADDITIONAL_TRANSPORT,
  });
}

function fetchAdditionalTransports({
  proposal,
  transportSearchCriteria,
  appContext,
}: {
  proposal: Proposal;
  transportSearchCriteria: TransportSearchCriteria;
  appContext: AppContext;
}) {
  return (dispatch: ReduxDispatch) => {
    dispatch(createAction(FETCH_ADDITIONAL_TRANSPORTS));
    const defaultTransport = proposal.transports;
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext,
      searchCriterias: transportSearchCriteria,
    }).then(
      ({ additionalTransports }) => {
        return dispatch(
          createAction(resolve(FETCH_ADDITIONAL_TRANSPORTS), {
            additionalTransports,
            selectedTransport: defaultTransport,
          }),
        );
      },
      (error) => {
        dispatch(createAction(reject(FETCH_ADDITIONAL_TRANSPORTS), error));
      },
    );
  };
}

export { FETCH_ADDITIONAL_TRANSPORTS, SEARCH_CRITERIA_TRANSPORTS, fetchAdditionalTransports };
